import type { CompositionRow } from "@shared/utils/lottiePlaygroundModel";
import { pathKey } from "@shared/utils/lottiePlaygroundModel";
import clsx from "clsx";

const KIND_DOT: Record<CompositionRow["kind"], string> = {
  layer: "bg-violet-500",
  group: "bg-amber-500",
  fill: "bg-emerald-500",
  stroke: "bg-sky-500",
  shape: "bg-zinc-500",
  other: "bg-zinc-600",
};

export interface CompositionTreeProps {
  rows: CompositionRow[];
  selectedKey: string | null;
  onSelect: (pathKey: string) => void;
}

export default function CompositionTree({ rows, selectedKey, onSelect }: CompositionTreeProps) {
  return (
    <div className="flex flex-col gap-1" data-testid="animation-playground-composition-tree">
      <p className="text-xs font-medium uppercase tracking-wide text-zinc-500">Composition</p>
      <ul className="max-h-[min(420px,50vh)] space-y-0.5 overflow-y-auto rounded-lg border border-zinc-800 bg-zinc-950/80 p-1">
        {rows.length === 0 ? (
          <li className="px-2 py-3 text-xs text-zinc-500">No Bodymovin layers found.</li>
        ) : (
          rows.map((row) => {
            const key = pathKey(row.path);
            const isSel = selectedKey === key;
            return (
              <li key={key}>
                <button
                  className={clsx(
                    "flex w-full items-start gap-2 rounded-md py-1.5 pr-2 text-left text-xs transition-colors",
                    isSel ? "bg-violet-950 text-zinc-50 ring-1 ring-violet-700/80" : "hover:bg-zinc-900 text-zinc-300"
                  )}
                  onClick={() => onSelect(key)}
                  style={{ paddingLeft: 10 + row.depth * 12 }}
                  type="button"
                >
                  <span aria-hidden className={clsx("mt-1 size-2 shrink-0 rounded-full", KIND_DOT[row.kind])} />
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-medium">{row.title}</span>
                    {row.detail ? <span className="block truncate text-[10px] text-zinc-500">{row.detail}</span> : null}
                  </span>
                </button>
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
}
